<script>
import Vue from 'vue';

let VSlider = Vue.options.components['VSlider'];

export default {
  extends: VSlider,
  methods: {
    onSliderClick(e) {
      this.isFocused = true;
      this.onMouseMove(e);
      this.$emit('change', this.internalValue);
      // emit sliderClick event so that we can use to do custom action
      // ex: For audio player, when the event occur set audio currentTime and play audio.
      this.$emit('sliderClick', this.internalValue);
    }
  }
};
</script>